import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@vant/touch-emulator'
import '@/assets/icons'
import SvgIcon from '@/components/SvgIcon'
import '@/style/index.scss'

const app = createApp(App)
app.component('svg-icon', SvgIcon)
app.use(store).use(router).mount('#app')
